/**
 * The jobs the console can launch.
 *
 * Adding one is a spec in this folder plus an entry here; the form, the payload
 * preview and the submit path are already generic over `JobSpec`.
 */
export * from './trainPerceptionModels';
export * from './buildJobInput';
export * from './types';
